module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-02-27 at 16.14.06.1572ff6f.jpeg";